import { registerComponentsI18next } from "@sg-protect/components";
import { navigateTo } from "@sg-protect/core";
import { registerODataI18next } from "@sg-protect/odata";
import { type ModuleRegisterFunction, getHomePaths, sharedReportsPaths } from "@sg-protect/shell";
import { redirect } from "react-router";

const registerBypassRoutes: ModuleRegisterFunction = runtime => {
    /**
     * This host app is used for protect, migrate, archives, reviews and shared reports.
     * We allow https://protect.sharegate.com/, https://migrate.sharegate.com/, https://reviews.sharegate.com/ and https://shared.sharegate.com/ to point to our app.
     * We want to allow https://migrate.sharegate.com/migrate, but we don't want https://migrate.sharegate.com/app/tenant-assessment to work.
     */
    const isMigrate = window.location.hostname.startsWith("migrate.");
    const isReviews = window.location.hostname.startsWith("reviews.");
    const isShared = window.location.hostname.startsWith("shared.");

    /**
     * This does the redirect, but this is also what makes https://protect.sharegate.com/ redirect to /home.
     * apps/home's entry route owns the landing decision from there — partner dashboard, Protect's Home, or
     * the legacy Home app. Otherwise, we would display a blank page since no route would match.
     *
     * The target carries no workspace id on purpose: a loader runs before the router renders, so the
     * workspace bootstrapping resolved is not readable here. The entry route reads it from context.
     */
    runtime.registerRoute({
        index: true,
        loader: () => {
            if (isMigrate) {
                navigateTo("/migrate");
                return null;
            }
            if (isReviews) {
                navigateTo("/reviews");
                return null;
            }
            if (isShared) {
                navigateTo(sharedReportsPaths.unavailable);
                return null;
            }
            return redirect(getHomePaths().entry);
        }
    });
};

export const registerHost: ModuleRegisterFunction = async runtime => {
    await registerComponentsI18next(runtime);
    await registerODataI18next(runtime);
    await registerBypassRoutes(runtime);
};
